if (!customElements.get('monsga-model-comparison')) {
  customElements.define('monsga-model-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.products = [...this.querySelectorAll('[data-mcp-product]')];
      this.columns = [...this.querySelectorAll('[data-mcp-column]')];
      this.values = [...this.querySelectorAll('[data-mcp-value]')];
      this.grid = this.querySelector('.mcp-table__grid');
      this.picker = this.querySelector('[data-mcp-picker]');
      this.status = this.querySelector('[data-mcp-status]');
      this.previous = this.querySelector('[data-mcp-previous]');
      this.next = this.querySelector('[data-mcp-next]');
      this.index = 0;
      this.previous?.addEventListener('click', () => this.select(this.index - 1));
      this.next?.addEventListener('click', () => this.select(this.index + 1));
      this.querySelector('[data-mcp-open-picker]')?.addEventListener('click', () => this.openPicker());
      this.querySelector('[data-mcp-close-picker]')?.addEventListener('click', () => this.closePicker());
      this.picker?.addEventListener('click', (event) => { if (event.target === this.picker) this.closePicker(); });
      this.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-mcp-remove]');
        const add = event.target.closest('[data-mcp-add]');
        if (remove) { this.removeProduct(remove.dataset.mcpRemove); return; }
        if (add) { this.addProduct(add.dataset.mcpAdd); return; }
        // 移动端（与 CSS 同一个断点）点产品图即切到该商品的参数列
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const media = event.target.closest('.mcp-table__product-media');
        if (media) this.selectSlot(media.closest('[data-mcp-product]')?.dataset.slot);
      });
      this.addEventListener('keydown', (event) => { if (event.key === 'ArrowLeft') this.select(this.index - 1); if (event.key === 'ArrowRight') this.select(this.index + 1); });
      this.refresh();
    }
    selectedSlots() { return this.products.filter((product) => product.hidden !== true).map((product) => product.dataset.slot); }
    refresh() {
      const slots = this.selectedSlots();
      this.dataset.productCount = String(slots.length);
      this.grid?.style.setProperty('--mcp-products', String(Math.max(slots.length, 1)));
      this.columns.forEach((column) => { column.hidden = !slots.includes(column.dataset.slot); });
      this.values.forEach((value) => { value.hidden = !slots.includes(value.dataset.slot); });
      this.products.forEach((product) => { product.hidden = !slots.includes(product.dataset.slot); });
      this.querySelectorAll('[data-mcp-add]').forEach((option) => { option.disabled = slots.includes(option.dataset.mcpAdd) || slots.length >= 3; });
      if (this.index >= slots.length) this.index = Math.max(0, slots.length - 1);
      this.select(this.index);
    }
    addProduct(slot) { const product = this.products.find((item) => item.dataset.slot === String(slot)); if (!product || this.selectedSlots().length >= 3) return; product.hidden = false; this.closePicker(); this.refresh(); }
    removeProduct(slot) { const product = this.products.find((item) => item.dataset.slot === String(slot)); if (!product || this.selectedSlots().length <= 1) return; product.hidden = true; this.refresh(); }
    openPicker() { if (this.picker?.showModal) this.picker.showModal(); else this.picker?.setAttribute('open', ''); }
    closePicker() { this.picker?.close?.(); this.picker?.removeAttribute('open'); }
    selectSlot(slot) { const index = this.selectedSlots().indexOf(String(slot)); if (index >= 0) this.select(index); }
    select(nextIndex) {
      const slots = this.selectedSlots();
      if (!slots.length) return;
      this.index = Math.max(0, Math.min(nextIndex, slots.length - 1));
      const slot = slots[this.index];
      this.products.forEach((product) => { product.dataset.mobileVisible = String(product.dataset.slot === slot); });
      this.values.forEach((value) => { value.dataset.mobileVisible = String(value.dataset.slot === slot); });
      this.columns.forEach((column) => { column.dataset.mobileVisible = String(column.dataset.slot === slot); });
      if (this.status) this.status.textContent = `${this.index + 1} / ${slots.length}`;
      if (this.previous) this.previous.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === slots.length - 1;
    }
  });
}
